import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ScheduleService } from '../../../../core/services/schedule/schedule.service';
import dayjs from 'dayjs';
import { ScheduledServicesModel } from '../../../../core/models/schedule/scheduledServicesModel';
import { DriverInformationModel } from '../../../../core/models/schedule/driver-information.model';
import { CompactVerticalTrackerComponent } from '../../../../shared/components/compact-vertical-tracker/compact-vertical-tracker.component';
import { NgClass } from '@angular/common';
import { isSourceFordPass } from '@core/utils';
import { AuthService, SessionService } from '@agenda-customer-ui/data-access';
import { StorageKeys } from '@core/enums';
import { IOpenSchedule } from '@core/interface';
import { OpenScheduleCardComponent } from 'libs/shared/src/lib/components/schedule/card/open/card-open-schedule.component';
import { DetailsComponent } from '../../../../shared/components/schedule-progress-card/details/details.component';

import { IUserProfileResponse } from '@core/interface';
// TODO: MUDAR O NOME NAO FAZ SENTIDO SER ESSE NOME

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-open-schedule',
    templateUrl: './open-schedule.component.html',
    styleUrls: ['./open-schedule.component.scss'],
    standalone: true,
    imports: [NgClass, CompactVerticalTrackerComponent, TranslateModule, OpenScheduleCardComponent, DetailsComponent]
})
export class OpenScheduleComponent implements OnInit {
  @Input() scheduleData: IOpenSchedule[] = [];
  @Output() reloadAfterCancelSchedule = new EventEmitter;
  hasDelivery = false;
  openModal = false;
  userProfile!: IUserProfileResponse;
  country = '';
  driveInformation!: DriverInformationModel;
  hasDriver = false;
  scheduleDetail!: IOpenSchedule;

  isSourceFordPass = false;
  openDetails = false;

  constructor(
    private translateService: TranslateService,
    private auth: AuthService,
    private scheduleService: ScheduleService,
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    this.initialize();
    this.isSourceFordPass = isSourceFordPass(this.auth.urlInfo.source);
  }

  initialize() {
    const vin = this.sessionService.getItem(StorageKeys.VIN_ACTIVE_DASHBOARD);
    this.userProfile = this.sessionService.getObject(StorageKeys.USER_PROFILE);
    this.country = this.sessionService.getItem(StorageKeys.COUNTRY);
    this.loadDriverInformationBySchedule(vin);
  }

  private loadDriverInformationBySchedule(vin: string) {
    const schedule = this.scheduleData.find((s) => s.vin === vin);
    if (schedule && schedule.pickupDelivery && !schedule.winchService) {
      this.getDriverData(schedule);
    }
  }

  getDriverData(schedule: IOpenSchedule) {
    this.scheduleService.getDriverSchedule(schedule).subscribe(
      (result) => {
        if (result) {
          this.driveInformation = result as DriverInformationModel;
          this.hasDriver = true;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  verifyDetailsState(event: boolean) {
    this.scheduleDetail = this.sessionService.getObject<IOpenSchedule>(StorageKeys.SCHEDULE_DETAILS);
    this.openDetails = event;
  }

  formateDate(scheduleDate: string, scheduleHour: number | string): string {
    const date = dayjs(scheduleDate).format('DD/MM/YYYY')
    const weekDay = new Date(scheduleDate).getDay();
    const hour = (scheduleHour.toString().length == 3) ? "0" + scheduleHour.toString().slice(0, 1) : scheduleHour.toString().substring(0, 2);
    const hourComplete = hour + ":" + scheduleHour.toString().slice(-2);
    return `${this.translateService.instant(`weekdays.${weekDay+1}`)}, ${date} - ${hourComplete}`
  }

  concatPickUpAndDeliveryWinchOrDriver(schedule: ScheduledServicesModel) {
    if (schedule.winchService) {
      return this.translateService.instant('schedule.pickup-delivery') +
      this.translateService.instant('schedule.schedule-details.winch-service');
    } else {
      return this.translateService.instant('schedule.pickup-delivery') +
      this.translateService.instant('schedule.schedule-details.driver-service');
    }
  }

  removeSchedule($event: number) {
    this.scheduleData = this.scheduleData.filter(schedule => schedule.scheduleId !== $event);
    this.reloadAfterCancelSchedule.emit(true);
  }
}
